/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectItemSubmittalsQuery } from '../../models/get-project-item-submittals-query';
import { GetProjectItemSubmittalsQueryResult } from '../../models/get-project-item-submittals-query-result';

export interface ApiProjectItemSubmittalsGetProjectItemSubmittalsPost$Params {
  
    /**
     * The query to retrieve a list of project item submittal.
     */
    body?: GetProjectItemSubmittalsQuery
}

export function apiProjectItemSubmittalsGetProjectItemSubmittalsPost(http: HttpClient, rootUrl: string, params?: ApiProjectItemSubmittalsGetProjectItemSubmittalsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemSubmittalsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSubmittalsGetProjectItemSubmittalsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectItemSubmittalsQueryResult>;
    })
  );
}

apiProjectItemSubmittalsGetProjectItemSubmittalsPost.PATH = '/api/ProjectItemSubmittals/GetProjectItemSubmittals';
